import api from "../../api"
import { getUserInfo } from "helpers/authHelper";
import { getRoleData, getRolewiseAccess } from "helpers/backend_helper";
import authHeader from "helpers/jwt-token-access/auth-token-header";
import { checkPermissionStatus, textCamelize } from "helpers/utils";
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { useTranslation } from "react-i18next";

const EditUserRole = ({ match }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [roleNameError, setRoleNameError] = useState(false);
  const [controllers, setControllers] = useState([]);
  const [controllerActions, setControllerActions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [controllerMappingInfo, setControllerMappingInfo] = useState({});

  const handleExpandAll = () => {
    setExpanded(!expanded);
  };

  const handleSelectAll = () => {
    setSelectedPermissions(prevPermissions => {
      if (!selectAll) {
        const updatedPermissions = {};
        Object.keys(controllerActions).forEach(controllerId => {
          updatedPermissions[controllerId] = controllerActions[
            controllerId
          ].map(action => action.id);
        });
        return updatedPermissions;
      } else {
        return {};
      }
    });
    setSelectAll(!selectAll);
    setControllerActions(controllerMappingInfo);
  };

  const handleParentChange = (value, parentId) => {
    parentId = parseInt(parentId);
    let allPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    if (value) {
      allPermissions[parentId] = controllerMappingInfo[parentId]?.map(el => {
        return el?.id;
      });
      checkSelectAll(allPermissions, controllerMappingInfo, "initial");
    } else {
      allPermissions[parentId] = [];
      setSelectAll(false);
    }
    setSelectedPermissions(allPermissions);
    // setControllerActions(controllerActions)
  };

  const handleRoleNameChange = event => {
    setRoleName(event.target.value);
    setRoleNameError(false);
  };

  const handleChildChange = (parentId, childId, isChecked) => {
    setSelectedPermissions(prevPermissions => {
      const updatedPermissions = { ...prevPermissions };

      if (!updatedPermissions[parentId]) {
        updatedPermissions[parentId] = [];
      }

      if (isChecked) {
        if (!updatedPermissions[parentId].includes(childId)) {
          updatedPermissions[parentId].push(childId);
        }
        checkSelectAll();
      } else {
        // Remove the childId if it exists
        updatedPermissions[parentId] = updatedPermissions[parentId].filter(
          id => id !== childId
        );

        // Remove the parentId key if there are no more childIds
        if (updatedPermissions[parentId].length === 0) {
          delete updatedPermissions[parentId];
        }
        setSelectAll(false);
      }

      return updatedPermissions;
    });
    // setControllerActions(controllerActions)
  };

  const fetchControllersMapInfo = async selectPermissions => {
    try {
      const token = authHeader();
      await api
        .get(`${process.env.REACT_APP_API_URL}/admin/role/getrolewiseactions`, {
          headers: {
            Authorization: token,
          },
        })
        .then(res => {
          setControllers(res?.data?.controllers);
          setControllerActions(res?.data?.data);
          setControllerMappingInfo(res?.data?.data);
          checkSelectAll(selectPermissions, res?.data?.data, "initial");
        })
        .catch(err => {
          console.error("Error fetching controllers:", err);
        });
    } catch (error) {
      console.error("Error fetching controllers:", error);
    }
  };

  useEffect(() => {
    getRoleInfo();
    document.title = "NeuroTal - Edit Role";
  }, []);

  const getRoleInfo = async () => {
    try {
      let roleId = match?.params?.role_id;
      if (!roleId) {
        return;
      }
      await getRoleData(roleId)
        .then(res => {
          setSelectedPermissions(res?.permissions || {});
          setRoleName(res?.roleInfo?.name || "");
          fetchControllersMapInfo(res?.permissions);
          // this.setState({ roleWiseAccess: res?.data?.dataList, roleInfo: res?.data?.roleInfo });
        })
        .catch(err => {
          console.log("route-error", err?.message);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const checkSelectAll = (selectPermissions, MappingInfo, type) => {
    let returnValue = true;
    let mapInfo = controllerMappingInfo;
    let permissions = selectedPermissions;
    if (type === "initial") {
      mapInfo = MappingInfo;
      permissions = selectPermissions;
    }
    let allKeys = Object.keys(mapInfo);
    let permissionsKeys = Object.keys(permissions);
    if (
      allKeys?.length !== permissionsKeys?.length ||
      (allKeys?.length === 0 && permissionsKeys?.length == 0)
    ) {
      returnValue = false;
    } else {
      for (let item of allKeys) {
        if (
          mapInfo.hasOwnProperty(item) &&
          permissions.hasOwnProperty(item) &&
          mapInfo[item]?.length !== permissions[item]?.length
        ) {
          returnValue = false;
        }
      }
    }
    setSelectAll(returnValue);
  };

  const handleSubmit = async () => {
    try {
      if (roleName?.trim() === "") {
        // setRoleNameError(true);
        toast.error(t(`Role List.Role Name is Required!`));
        return;
      }

      await api.post(`${process.env.REACT_APP_API_URL}/admin/role/update-role`, {
        name: roleName,
        alias: textCamelize(roleName),
        permissions: JSON.stringify(selectedPermissions),
        sequence: "2",
        roleId: match?.params?.role_id,
      });
      toast.success(t(`Role List.Role Updated Successfully!`));
    } catch (error) {
      toast.error(t(`Role List.Something Went Wrong`));
      // console.error("API Request Error:", error);
    }
  };

  const checkParentStatus = parentId => {
    parentId = parseInt(parentId);
    return (
      selectedPermissions[parseInt(parentId)]?.length ===
      controllerMappingInfo[parseInt(parentId)]?.length
    );
  };

  const checkChildStatus = (parentId, childId) => {
    parentId = parseInt(parentId);
    let returnValue = false;
    let allPermissions = selectedPermissions;
    returnValue = allPermissions[parentId]?.includes(childId);
    return returnValue;
  };

 
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
 if (!checkPermissionStatus("role-list", "edit")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Role List.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <div className="pending-list-page feedbacks">
      <div className="right-side-wrapper">
        {/* <div className="d-flex gap-2 w-100 create-user-heading  mb-4 align-items-center border-bottom py-1 pt-0">
          <div className="page-heading w-100">
            <h1 className="title-lg heading-twentyfour">
              Edit User Role / Role Permissions
            </h1>
          </div>
          <div className="bck_btn mb-3">
            <Link to={`/role-list`} className="btn btn-primary">
              <img
                src="https://recruit.neurotal.com.au/neuronimbus/assets/images/svg/back-btn-arrow.svg"
                alt="bck btn"
              />
              Back
            </Link>
          </div>
        </div> */}

        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center py-2 pt-0 depart-content">
            <Col lg="6" md="6">
              <Link to="/role-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`Role List.Edit User Role / Role Permissions`)}
                </h5>
              </Link>
            </Col>
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy mt-3">
          <div className="table-outer-wrapper bg-white">
            <div className="table-form-role d-flex align-items-center mb-4 ">
              <div className="create-user-table w-100 d-flex align-items gap-2">
                <div className="clearfix mb40 w-100 ">
                  <label className="control-label" htmlFor="role_name">
                    {t(`Role List.Role Name`)}
                    <span className="text-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="role_name"
                    name="role_name"
                    className={`form-control ${
                      roleNameError ? "is-invalid" : ""
                    }`}
                    value={roleName}
                    maxLength="100"
                    onChange={handleRoleNameChange}
                    placeholder={`${t(`Role List.Role Name`)} *`}
                  />
                  {roleNameError && (
                    <p className="error text-sm text-red">
                      {t(`Role List.The Role Name field is required`)}
                    </p>
                  )}
                </div>
                <div className="select-all d-flex justify-content-end align-items-center gap-4">
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="all"
                      name="check-all"
                      className="mx-1"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                    <label htmlFor="all">{t(`Role List.Select All`)}</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="cards-section cadidate-details roloe mt-2 p-0">
              <form
                action="https://recruit.neurotal.com.au/neuronimbus/admin/user_roles/add"
                id="frm-ur-add"
                role="form"
                noValidate
                method="post"
                acceptCharset="utf-8"
              >
                <div className="tabel-application tabel-application-auto table-responsive white-space-row">
                  <table className="table table-striped table-responsive">
                    <thead>
                      <tr>
                        <th>{t(`Role List.Controller`)}</th>
                        <th>{t(`Role List.Actions`)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(controllerActions).map(
                        ([controllerId, actions]) => (
                          <tr key={controllerId}>
                            <td>
                              <div className="checkbox-accordion-list">
                                <ul>
                                  <li>
                                    <input
                                      type="checkbox"
                                      name={`permission${controllerId}`}
                                      id={`parent${controllerId}`}
                                      className="parent"
                                      checked={checkParentStatus(controllerId)}
                                      onChange={e => {
                                        handleParentChange(
                                          e.target.checked,
                                          controllerId
                                        );
                                      }}
                                    />
                                    <label htmlFor={`parent${controllerId}`}>
                                      {
                                        controllers.find(
                                          controller =>
                                            controller.id ===
                                            parseInt(controllerId, 10)
                                        )?.controller_label
                                      }
                                    </label>
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td>
                              <div className="checkbox-accordion-list">
                                <ul className="actions-list">
                                  {actions.map(action => (
                                    <li key={`${controllerId}${action?.id}`}>
                                      <input
                                        type="checkbox"
                                        name={`child${action.id}`}
                                        className="child"
                                        id={`${controllerId}${action?.id}`}
                                        checked={
                                          checkChildStatus(
                                            controllerId,
                                            action?.id
                                          ) || false
                                        }
                                        onChange={event =>
                                          handleChildChange(
                                            controllerId,
                                            action.id,
                                            event.target.checked
                                          )
                                        }
                                      />
                                      <label htmlFor={`aid${action.id}`}>
                                        {action?.action_label}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="form-cta_btn rolest text-center mt-4 d-flex gap-3 justify-content-start">
                  {/* <Link to="/role-list" className="btn btn-primary reset">
                    <img
                      src="https://recruit.neurotal.com.au/neuronimbus/assets/images/svg/back-btn-arrow.svg"
                      alt="bck btn"
                    />
                    {t(`Role List.Cancel`)}
                  </Link> */}
                  <input
                    type="button"
                    name="submitbtn"
                    id="submitbtn"
                    value={t(`Role List.Submit`)}
                    className="btn btn-primary search"
                    onClick={handleSubmit}
                  />
                </div>
              </form>

              {/* <form
                action="https://recruit.neurotal.com.au/neuronimbus/admin/user_roles/add"
                id="frm-ur-add"
                role="form"
                noValidate
                method="post"
                acceptCharset="utf-8"
              >
                <div className="checkbox-accordion-wrapper">
                  <div className="accordion" id="accordionExample">
                    {Object.entries(controllerActions).map(
                      ([controllerId, actions]) => (
                        <div key={controllerId} className="accordion-item">
                          <h2
                            className="accordion-header"
                            id={`heading${controllerId}`}
                          >
                            <button
                              className={`accordion-button ${
                                expanded ? "collapsed" : ""
                              }`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${controllerId}`}
                              aria-expanded={expanded}
                              aria-controls={`collapse${controllerId}`}
                            >
                              <input
                                type="checkbox"
                                name={`permission${controllerId}`}
                                id={`parent${controllerId}`}
                                className="parent"
                                checked={checkParentStatus(controllerId)}
                                // value={selectedPermissions[parseInt(controllerId)]?.length === controllerMappingInfo[parseInt(controllerId)]?.length}
                                onChange={e => {
                                  handleParentChange(
                                    e.target.checked,
                                    controllerId
                                  );
                                }}
                              />
                              <span htmlFor={`parent${controllerId}`}>
                                {
                                  controllers.find(
                                    controller =>
                                      controller.id ===
                                      parseInt(controllerId, 10)
                                  )?.controller_label
                                }
                              </span>
                            </button>
                          </h2>
                          <div
                            id={`collapse${controllerId}`}
                            className={`accordion-collapse collapse ${
                              expanded ? "show" : ""
                            }`}
                            aria-labelledby={`heading${controllerId}`}
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <div className="checkbox-accordion-list">
                                <ul>
                                  {actions.map(action => (
                                    <li key={`${controllerId}${action?.id}`}>
                                      <input
                                        type="checkbox"
                                        name={`child${action.id}`}
                                        className="child"
                                        id={`${controllerId}${action?.id}`}
                                        checked={
                                          checkChildStatus(
                                            controllerId,
                                            action?.id
                                          ) || false
                                        }
                                        onChange={event =>
                                          handleChildChange(
                                            controllerId,
                                            action.id,
                                            event.target.checked
                                          )
                                        }
                                      />

                                      <span htmlFor={`aid${action.id}`}>
                                        {action?.action_label}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>

                <div className="form-cta_btn rolest text-center mt-4 d-flex gap-3 justify-content-start">
                  <a href="../role-list" className="btn btn-primary reset">
                    <img
                      src="https://recruit.neurotal.com.au/neuronimbus/assets/images/svg/back-btn-arrow.svg"
                      alt="bck btn"
                    />
                    Cancel
                  </a>
                  <input
                    type="button"
                    name="submitbtn"
                    id="submitbtn"
                    value="Submit"
                    className="btn btn-primary search"
                    onClick={handleSubmit}
                  />
                </div>
              </form> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserRole;
